import * as React from 'react';
import * as _ from 'lodash';
import { IFilterGroup } from './shared-types';
import { CheckboxFilterItem } from './checkbox-filter-item';

export interface ICheckboxFilterGroupProps {
    name: string,
    filterGroup: IFilterGroup,
    classes?: Array<string>,
    appliedValues: Array<any>,
    availableValues: Array<any>,
    preventDisable: boolean,
    onChangeHandler(value: any): void
}

export interface ICheckboxFilterGroupState {
    collapsed: boolean
}

export class CheckboxFilterGroup extends React.Component<ICheckboxFilterGroupProps, ICheckboxFilterGroupState>{

    constructor(props: ICheckboxFilterGroupProps) {
        super(props);
        this.state = { collapsed: false };
    }

    private getClassName(): string {
        let className = 'filters-section filters-checkbox';
        if (!_.isNil(this.props.classes) && this.props.classes.length)
            className = className.concat(' ', this.props.classes.join(' '));
        if (this.state.collapsed)
            className = className.concat(' filtersAreCollapsed');
        return className;
    }

    public onClickHandler(): void {
        this.setState((prevState: ICheckboxFilterGroupState) => {
            return { collapsed: !prevState.collapsed }
        });
    }

    render() {
        return (
            <div className={this.getClassName()}>
                <div className="filters-section-header" onClick={this.onClickHandler.bind(this)}>
                    {this.props.appliedValues.length > 0 &&
                        <h6 className="filters-section-count">
                            {this.props.appliedValues.length}
                        </h6>
                    }
                    <h6 className="filters-section-label">{this.props.filterGroup.header}</h6>
                </div>
                {
                    this.props.filterGroup.filters.map((x, i) =>
                        <CheckboxFilterItem key={i}
                            id={this.props.name + i}
                            name={this.props.name}
                            label={x.text}
                            value={x.value}
                            isChecked={this.props.appliedValues.indexOf(x.value) !== -1}
                            disabled={!this.props.preventDisable && this.props.availableValues.indexOf(x.value) === -1}
                            onChangeHandler={this.props.onChangeHandler} />
                    )
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/checkbox-filter-group.tsx